import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { accountIdFormat, locationIdFormat } from "../ids";

export enum TaskDomain {
  WAREHOUSE = "warehouse",
}

export const TaskDomainSchema = createEnum(TaskDomain);

export enum TaskSubtype {
  REPLENISHMENT = "replenishment",
  COUNT = "count",
}

export const TaskSubtypeSchema = createEnum(TaskSubtype);

export enum TaskStatus {
  OPEN = "open",
  CLAIMED = "claimed",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export const TaskStatusSchema = createEnum(TaskStatus);

export enum TaskPriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  URGENT = "urgent",
}

export const TaskPrioritySchema = createEnum(TaskPriority);

export const TaskReferenceSchema = z.object({
  referenceTable: z.string(),
  referenceId: z.string(),
});
export interface TaskReference extends z.infer<typeof TaskReferenceSchema> {}

const TaskSchema_ = z.object({
  id: z.string(),
  accountId: accountIdFormat.schema,
  locationId: locationIdFormat.schema.nullable(),
  name: z.string().nullable(),
  domain: TaskDomainSchema,
  subtype: TaskSubtypeSchema,
  status: TaskStatusSchema,
  priority: TaskPrioritySchema,
  /** @deprecated Use references instead */
  referenceType: z.string(),
  /** @deprecated Use references instead */
  referenceId: z.string(),
  references: z.array(TaskReferenceSchema),
  createdByLegacyUserId: z.string().nullable(),
  claimedByLegacyUserId: z.string().nullable(),
  completedByLegacyUserId: z.string().nullable(),
  dueAt: z.date().nullable(),
  claimedAt: z.date().nullable(),
  completedAt: z.date().nullable(),
  cancelledAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const TaskSchema: z.ZodType<Task> = TaskSchema_;
export interface Task extends z.infer<typeof TaskSchema_> {}
